<template>
    <div class="project-teaser">
        <div class="project-teaser__inner">
            <div class="project-teaser__image">
                <img :src="project.bild" alt="Projekt Bild">
            </div>
            <h3 class="project-teaser__header">
                {{ project.titel }} <br>
            </h3>
            <p class="project-teaser__address">
                <span>
                    {{ project.projekttraeger_organisation }}
                </span>
                <span>
                    {{ projectLocation.street }} {{ projectLocation.number }}
                </span>
                <span>
                    {{ projectLocation.zipcode }} {{ projectLocation.city }}
                </span>
            </p>
            <p class="project-teaser__text" v-html="projectText"></p>
            <div class="project-teaser__footer">
                <template v-if="!isClosed">
                    <div class="project-teaser__budget-info-slot">
                        {{ project.hearts_count }}
                        {{ project.hearts_count > 1 || project.hearts_count === 0 ? 'Herzen' : 'Herz' }} gesammelt
                    </div>
                    <div class="project-teaser__budget-info-slot">{{ budgetInEuro }} € erreicht</div>
                    <div class="project-teaser__budget-info-bar">
                        <span class="project-teaser__budget-info-bar-bg" :style="budgetInfoBarStyle"></span>
                        <span class="project-teaser__budget-info-bar-label">
                            {{ budgetPercent }}% von {{ budgetTargetInEuro }} € erreicht
                        </span>
                    </div>
                </template>
                <template v-else>
                    <div class="project-teaser__closed">
                        <span class="mdi mdi-check"></span>
                        Dieses Projekt ist abgeschlossen
                    </div>
                </template>
                <div class="project-teaser__trigger">
                    <router-link
                        class="btn btn--blue"
                        :to="{ name: 'PageDetail', params: { id: project.id}}"
                    >
                        zum Projekt
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProjectBudget from '@/mixins/ProjectBudget'
import ProjectLocation from '@/mixins/ProjectLocation'

export default {
    name: 'ProjectTeaser',

    mixins: [
        ProjectBudget,
        ProjectLocation
    ],

    props: {
        project: {
            required: true,
            type: Object
        }
    },

    computed: {
        isClosed () {
            return this.project.archiviert || !this.project.hearts_left
        },

        projectText () {
            if (!this.project) {
                return ''
            }
            return this.project.logkurzbeschreibungo.replace(/\n/g, '<br>')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ProjectTeaser.vue